/*=========================================================================================
  File Name: moduleNews.js
  Description: News Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleNotificationState.js'
import mutations from './moduleNotificationMutations.js'
import actions from './moduleNotificationActions.js'
import getters from './moduleNotificationGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
